import { Navigate, useParams } from 'react-router-dom';
import { PATH_AUTH } from '@/routes/paths';

/**
 * O link que o parceiro do Cakto Partners divulga (`/p/<código>/`). O destino é o mesmo do
 * redirect que a API faz no `/p/` dela: o cadastro guarda o `?ref=`, busca a grafia canônica no
 * `/resolve/` e descarta o código que não existe, e o GuestGuard de lá trata quem já tem sessão.
 * Como só redireciona, a rota fica fora dos providers de sessão.
 */
function PartnerLinkRedirect() {
  const { code } = useParams();

  // O código vem de uma URL divulgada fora do painel: um `&` ou `+` cru mudaria a query.
  return <Navigate to={`${PATH_AUTH.register}?ref=${encodeURIComponent(code)}`} replace />;
}

export const partnerLinkRoute = { path: 'p/:code', element: <PartnerLinkRedirect /> };
